/**
 * バンドルミックスマッチ設定画面　企画商品情報取得VOクラス
 */
export class KYMW1308GetPlanGoodsInfoModel {
  /** 受注コード */
  public orderCode: string = null;
  /** Ｐコードリスト */
  public pCodeList: Array<any> = new Array<any>();
}
